import React, { Component, Fragment } from "react";
import Chart from "react-apexcharts";
import util from "./util";
import Select from "../Grafico/Select";

export default class Grafico4 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            metas: [],
            dados: [],
            realizados: [],
            acumulado: {},
            mesSelecionado: this.props.mesSelecionado,
            isAcumulado: false,
            modalidade: "5 Iniciação Profissional",
            unidade: "DR",
            nomeCampo: "Matrículas",
            selectUnidade: "DR",
            selectModalidade: "5 Iniciação Profissional",
            selectMetaRealizado: "metas",
            selectCampo: "matricula",
            series: [],
            options: {

                chart: {
                    height: 350,
                    type: 'line',
                    toolbar: {
                        show: false
                    },
                },

                colors: ['#77B6EA', '#545454', '#FEBC3B', "#51CBCE"],

                plotOptions: {
                    bar: {
                      dataLabels: {
                        position: 'top',
                      },
                    }
                },

                dataLabels: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                    },
                    style: {
                        fontSize: '13px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'bold',
                        colors: ["#304758"]
                    },
                    offsetY: -20
                },

                stroke: {
                    curve: 'smooth'
                },

                title: {
                    text: 'Total',
                    align: 'left'
                },

                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },

                markers: {
                    size: 1
                },

                xaxis: {
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                    title: {
                        text: 'Mês'
                    }
                },

                yaxis: {
                    title: {
                        text: 'TOTAL'
                    },
                    //min: 5,
                    //max: 40,
                    //opposite: true,
                    labels: {
                        formatter: function (value) {
                            if (Number.isFinite(value)) {
                                return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                            }
                            else {
                                return 0
                            }
                        }
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5,
                    formatter: function(seriesName, opts) {
                        seriesName = seriesName === "Total" ? "Total" : seriesName;
                        return [seriesName]
                    }
                }
            
            }

        }
    }

async componentDidMount() {
    this.calculaTipoPorMes();
}

async componentDidUpdate(prevProps, prevState) {
    if(this.props.mesSelecionado !== prevProps.mesSelecionado) {
        this.calculaTipoPorMes();
    }
}

calculaTipoPorMes = async (event) => {

    let valor = event ? event.target.value : null;
    let id = event ? event.target.id : null;

    let { selectUnidade, selectModalidade, selectMetaRealizado, selectCampo, isAcumulado } = this.state;

    if(id === "isAcumulado") {
        if(valor === "mensal") isAcumulado = false;
        if(valor === "acumulado") isAcumulado = true;
    }

    let { dados, realizados, acumulado } = await util.fetchDados(this.state.mesSelecionado, isAcumulado);

    if (id === "selectUnidade") {
        selectUnidade = valor;
    }
    if (id === "selectModalidade") {
        selectModalidade = valor;
    }
    if (id === "selectMetaRealizado") {
        selectMetaRealizado = valor;
    }
    if (id === "selectCampo") {
        selectCampo = valor;
    }

    let indice = dados && dados.findIndex(unidade => unidade.unidade === selectUnidade);

    let realizado1 = new Array(12).fill(0);
    let realizado2 = new Array(12).fill(0);
    let realizado3 = new Array(12).fill(0);
    let meta1 = new Array(12).fill(0);
    let meta2 = new Array(12).fill(0);
    let meta3 = new Array(12).fill(0);

    let stateSeries = undefined;

    try {

        if(selectMetaRealizado === "metasrealizados") {

            if(selectModalidade === "Todas") {
                meta1 = (dados[indice] && util.todasAsModalidades(dados[indice]["metas"]))[`${selectCampo}_regimental`]
                meta2 = (dados[indice] && util.todasAsModalidades(dados[indice]["metas"]))[`${selectCampo}_nao_regimental`]
                meta3 = (dados[indice] && util.todasAsModalidades(dados[indice]["metas"]))[`${selectCampo}_pago`]

                realizado1 = (dados[indice] && util.todasAsModalidades(dados[indice]["realizados"]))[`${selectCampo}_regimental`]
                realizado2 = (dados[indice] && util.todasAsModalidades(dados[indice]["realizados"]))[`${selectCampo}_nao_regimental`]
                realizado3 = (dados[indice] && util.todasAsModalidades(dados[indice]["realizados"]))[`${selectCampo}_pago`]
            }
            else {
                meta1 = dados[indice] && dados[indice]["metas"][selectModalidade] && dados[indice]["metas"][selectModalidade][`${selectCampo}_regimental`]     ? dados[indice]["metas"][selectModalidade][`${selectCampo}_regimental`]     : meta1;
                meta2 = dados[indice] && dados[indice]["metas"][selectModalidade] && dados[indice]["metas"][selectModalidade][`${selectCampo}_nao_regimental`] ? dados[indice]["metas"][selectModalidade][`${selectCampo}_nao_regimental`] : meta2;
                meta3 = dados[indice] && dados[indice]["metas"][selectModalidade] && dados[indice]["metas"][selectModalidade][`${selectCampo}_pago`]           ? dados[indice]["metas"][selectModalidade][`${selectCampo}_pago`]           : meta3;
    
                realizado1 = dados[indice] && dados[indice]["realizados"][selectModalidade] && dados[indice]["realizados"][selectModalidade][`${selectCampo}_regimental`]     ? dados[indice]["realizados"][selectModalidade][`${selectCampo}_regimental`]     : realizado1;
                realizado2 = dados[indice] && dados[indice]["realizados"][selectModalidade] && dados[indice]["realizados"][selectModalidade][`${selectCampo}_nao_regimental`] ? dados[indice]["realizados"][selectModalidade][`${selectCampo}_nao_regimental`] : realizado2;
                realizado3 = dados[indice] && dados[indice]["realizados"][selectModalidade] && dados[indice]["realizados"][selectModalidade][`${selectCampo}_pago`]           ? dados[indice]["realizados"][selectModalidade][`${selectCampo}_pago`]           : realizado3;
            }

            let pagoJ = this.formataMetaRealizado(realizado3, meta3, "Pago");
            let regimentalJ = this.formataMetaRealizado(realizado1, meta1, "Gratuidade Regimental");
            let nao_regimental = this.formataMetaRealizado(realizado2, meta2, "Gratuidade Não-Regimental");

            stateSeries = [
                {
                    name: "Pago (Realizado)",
                    data: pagoJ
                },
                {
                    name: "Gratuidade Regimental (Realizado)",
                    data: regimentalJ
                },
                {
                    name: "Gratuidade Não-Regimental (Realizado)",
                    data: nao_regimental
                }
            ];

        }
        else {

            if(selectModalidade === "Todas") {
                realizado1 = (dados[indice] && util.todasAsModalidades(dados[indice][selectMetaRealizado]))[`${selectCampo}_regimental`]
                realizado2 = (dados[indice] && util.todasAsModalidades(dados[indice][selectMetaRealizado]))[`${selectCampo}_nao_regimental`]
                realizado3 = (dados[indice] && util.todasAsModalidades(dados[indice][selectMetaRealizado]))[`${selectCampo}_pago`]
            }
            else {
                realizado1 = dados[indice] && dados[indice][selectMetaRealizado][selectModalidade] && dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_regimental`]     ? dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_regimental`]     : realizado1;
                realizado2 = dados[indice] && dados[indice][selectMetaRealizado][selectModalidade] && dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_nao_regimental`] ? dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_nao_regimental`] : realizado2;
                realizado3 = dados[indice] && dados[indice][selectMetaRealizado][selectModalidade] && dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_pago`]           ? dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_pago`]           : realizado3;
            }

            stateSeries = [
                {
                    name: "Pago",
                    data: realizado3
                },
                {
                    name: "Gratuidade Regimental",
                    data: realizado1
                },
                {
                    name: "Gratuidade Não-Regimental",
                    data: realizado2
                }
            ]

        }
    }
    catch (erro) {
    }

    this.setState({
        series: stateSeries,
        options: {
            title: {
                text: selectUnidade
            }
        },
        selectUnidade,
        selectModalidade,
        selectMetaRealizado,
        dados,
        realizados,
        acumulado,
        selectCampo,
        isAcumulado
    });

}

formataMetaRealizado = (valores, meta, tipo) => {
    let pagoJ = valores.map((val, i) => {
        let j = {
            x: '2018' + i,
            y: val,
            goals: [
                {
                    name: `${tipo} (Meta)`,
                    value: meta[i],
                    strokeHeight: 2,
                    //strokeDashArray: 2,
                    //strokeColor: '#775DD0'
                }
            ]
        }
        return j
    });
    return pagoJ;
}

render() {
    return (
        <Fragment>

            <div className="card ">
                <div className="card-header ">
                    <div className="row">
                        <div className="col-md-2">
                            <h5 className="card-title">{this.state.selectCampo === "matricula" ? "Matrículas" : "Hora Aluno"}</h5>
                            <h6>{this.state.selectModalidade}</h6>
                        </div>
                        <div className="col-md-2">
                            <Select select={this.calculaTipoPorMes} campo="visao" idComponente="isAcumulado" />
                        </div>
                        <div className="col-md-2">
                            <Select select={this.calculaTipoPorMes} campo="campos" idComponente="selectCampo" />
                        </div>
                        <div className="col-md-2">
                            <Select select={this.calculaTipoPorMes} campo="tipos" idComponente="selectMetaRealizado" />
                        </div>
                        <div className="col-md-2">
                            <Select select={this.calculaTipoPorMes} campo="unidades" idComponente="selectUnidade" />
                        </div>
                        <div className="col-md-2">
                            <Select select={this.calculaTipoPorMes} />
                        </div>
                    </div>
                </div>
                <div className="card-body ">
                    <div className="mixed-chart">
                        <Chart options={this.state.options} series={this.state.series} type="bar" height={"300"} />
                    </div>
                </div>
                <div className="card-footer ">
                    <hr />
                    <div className="stats">
                        <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                        {/*
                            <span style={{ float: 'right' }}>
                                <button className="btn btn-outline-primary btn-round btn-sm" style={{ fontSize: '0.500em' }}>
                                    Visão Unidades
                                </button>
                            </span>
                        */}
                    </div>
                </div>
            </div>

        </Fragment>
    )
}
}